import { isNil } from 'lodash'

const getAssetRoute = (viewMap, currentDefaultPage) => {
  // when viewMap not yet defined (on first load and not yet navigated to TrackingView), we rely on currentDefaultPage to determine the default view
  if (isNil(viewMap)) {
    if (currentDefaultPage === 'asset-list') {
      return { name: 'asset', params: { defaultMode: 'list' } }
    }
    return { name: 'asset', params: { defaultMode: 'map' } }
  }
  // else we rely on the previously selected viewMode
  return {
    name: 'asset',
    params: { defaultMode: viewMap ? 'map' : 'list' },
  }
}

const getAssetUrl = (viewMap, currentDefaultPage, router) => {
  return router.resolve(getAssetRoute(viewMap, currentDefaultPage)).href
}

export { getAssetRoute, getAssetUrl }
